export default function Ornament({ className = "", light = false }) {
  const style = light ? { color: "#d4af37" } : undefined;
  return (
    <div className={`ornament ${className}`} aria-hidden="true" style={style}>
      <span>✦</span>
      <span style={{ fontSize: "0.9rem" }}>✜</span>
      <span>✦</span>
    </div>
  );
}
